import { authGet } from "@api";

import { ProjectAnalyticsResponse } from "@pages/overview/types";

export const fetchDemoProjectStats = (
  deploymentId: string
): Promise<ProjectAnalyticsResponse> => {
  return authGet<ProjectAnalyticsResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/demo_project`
  );
};
